<template>
  <div>
    <div class="slider text-center">
      <div class="shap-one" style="pointer-events: none;"></div>
      <div class="shap-two" style="pointer-events: none;"></div>
      <div class="heart">
        <div class="content">
          <img class="svg" src="@/assets/dashboard/svg/slider/1.svg" alt="...">
        </div>
      </div>
      <div class="group">
        <div class="content">
          <img class="svg rotate" src="@/assets/dashboard/svg/slider/2.svg" alt="...">
        </div>
      </div>
      <div class="line-one" style="pointer-events: none;">
        <img class="svg" src="@/assets/dashboard/svg/slider/3.svg" alt="...">
      </div>
      <div class="line-two" style="pointer-events: none;">
        <img class="svg" src="@/assets/dashboard/svg/slider/4.svg" alt="...">
      </div>
      <div class="line-three" style="pointer-events: none;">
        <img class="svg" src="@/assets/dashboard/svg/slider/5.svg" alt="...">
      </div>
      <div class="container">
        <div class="heading">
          <h3>Welcome Back, <span>{{ user.firstName }}</span>!</h3>
          <p>Are you ready for your next lesson ?</p>
        </div>
        <div class="learn-today">
          <div class="row">
            <div class="col-md-10">
              <form method="POST" action="">
                <input type="text" name="search" placeholder="What do you want to Learn Today ?">
                <button type="submit">
                  <img src="@/assets/dashboard/img/search2.png">
                </button>
              </form>
              <div class="row">
                <div class="col-4" style="z-index: 10000;">
                  <router-link to="/my-courses" class="lesson">My Lessons</router-link>
                </div>
                <div class="col-4" style="z-index: 10000;">
                  <a href="#" class="profile">My Portfolio</a>
                </div>
                <div class="col-4" style="z-index: 10000;">
                  <a href="https://uaeafter2pm.org/en/profile" class="settings">Settings</a>
                </div>
              </div>
            </div>
            <div class="col-md-2" style="cursor: pointer">
              <router-link to="/categories" style="text-decoration: none;">
                <button type="submit" class="plus">
                  +
                </button>
                <p>Add New Course</p>
              </router-link>
            </div>
          </div>
        </div>
        <div class="courses">
          <div class="row">
            <div class="col-md-4">
              <div class="content">
                <div class="shap-light"></div>
                <h2>{{ coursesCount }}</h2>
                <div class="disc">
                  <div class="shap-dot"></div>
                  <h3>Enrolled<br>Courses</h3>
                  <hr>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="content">
                <div class="shap-light"></div>
                <h2>{{ completedCoursesCount }}</h2>
                <div class="disc">
                  <div class="shap-dot"></div>
                  <h3>Completed<br>Courses</h3>
                  <hr>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="content">
                <div class="shap-light"></div>
                <h2>{{ pathCount }}</h2>
                <div class="disc">
                  <div class="shap-dot"></div>
                  <h3>Learning<br>Path</h3>
                  <hr>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" style="z-index: 12000;" id="bookOfficeHours" tabindex="-1"
         aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger" id="exampleModalLabel">Book Office Hours</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <Booking/>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-warning" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Booking from "@/components/Booking";

export default {
  components: {Booking},
  mounted() {
    this.$store.dispatch('auth/getCompletedCoursesCount');
  },
  computed: {
    user() {
      return this.$store.getters["auth/userData"];
    },
    completedCoursesCount() {
      return this.$store.getters["auth/completedCoursesCount"];
    },
    pathCount() {
      return this.$store.getters["auth/pathCount"];
    },
    coursesCount() {
      return this.$store.getters["auth/coursesCount"];
    }
  }
}
</script>

<style lang="scss" scoped>
.rotate {
  transform: rotate(180deg);
}

.svg {
  width: 44px;
  height: 44px;
  position: relative;
  top: 19px;
}

.slider {
  background: #003827;
  position: relative;
  padding: 200px 0 50px 0;
  overflow: hidden;

  .shap-one {
    position: absolute;
    width: 1733px;
    height: 1733px;
    left: -1004px;
    top: -794px;
    background: radial-gradient(38.86% 38.86% at 50% 50%, #00E384 0%, rgba(26, 25, 29, 0) 100%);
  }

  .shap-two {
    position: absolute;
    width: 1417px;
    height: 1417px;
    left: 1324px;
    top: -307px;
    background: radial-gradient(38.86% 38.86% at 50% 50%, #00E384 0%, rgba(26, 25, 29, 0) 100%);
  }

  .heart {
    position: absolute;
    width: 139px;
    height: 96px;
    left: 0;
    top: 223px;
    background: linear-gradient(90deg, #FFFFFF -3.6%, rgba(255, 255, 255, 0) 137.77%);
    border-radius: 48px 0px 0px 50px;
    transform: rotate(180deg);

    .content {
      width: 80px;
      height: 80px;
      background: linear-gradient(138.01deg, #232323 0%, #161616 117.01%);
      transform: rotate(180deg);
      border-radius: 50%;
      position: absolute;
      top: 8px;
      right: 52px;

      svg {
        width: 44px;
        height: 44px;
        position: relative;
        top: 19px;
      }
    }
  }

  .group {
    @extend .heart;
    right: 0;
    left: unset;
    transform: unset;

    .content {
      svg {
        transform: rotate(180deg);
      }
    }
  }

  .line-one {
    position: absolute;
    width: 2696.5px;
    height: 453.88px;
    left: -158.32px;
    top: 207.44px;
    border-radius: 500px;
    transform: rotate(4.11deg);
  }

  .line-two {
    position: absolute;
    width: 2696.5px;
    height: 453.88px;
    left: -171.09px;
    top: 268.33px;
    border-radius: 500px;
    transform: rotate(-6.54deg);
  }

  .line-three {
    position: absolute;
    width: 2696.5px;
    height: 453.88px;
    left: -179px;
    top: 318.74px;
    border-radius: 500px;
    transform: rotate(-15.52deg);
  }

  .heading {
    margin-bottom: 40px;

    h3 {
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 64px;
      line-height: 69px;
      color: #FFFFFF;
    }

    p {
      font-family: Roboto;
      font-style: normal;
      font-weight: 300;
      font-size: 24px;
      line-height: 131%;
      color: #FFFFFF;
    }
  }

  .learn-today {
    padding: 0 15% 112px 15%;

    form {
      position: relative;
      margin-bottom: 24px;
      margin-left: 2px;

      input {
        width: 100%;
        background: linear-gradient(90.02deg, rgba(255, 255, 255, 0.25) 0.97%, rgba(255, 255, 255, 0) 99.99%);
        border-radius: 5px;
        border: none;
        padding: 10px 30px;
      }

      ::placeholder {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 98.3%;
        color: #FFFFFF;
        opacity: 1;
      }

      button {
        position: absolute;
        top: 0;
        right: 0;
        padding: 10px;
        background: none;
        border: none;
      }
    }

    .lesson {
      background: linear-gradient(90deg, #00FF85 0%, rgba(0, 255, 133, 0) 222.91%);
      border-radius: 4px;
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 98.3%;
      color: #FFFFFF;
      text-decoration: none;
      padding: 14px 44px;
      margin-right: 34px;
      display: inline-block;
      width: 100%;
    }

    .profile {
      @extend .lesson;
    }

    .settings {
      @extend .lesson;
      margin-right: 0;
      border: 10px solid;
      border-image-slice: 1;
      border-width: 1px;
      border-image-source: linear-gradient(to right, #00F37E, #013a1f);
      background: unset;
    }
  }

  .plus {
    border: 2px solid #00F07E;
    box-sizing: border-box;
    border-radius: 17px;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 72px;
    line-height: 107.19%;
    color: #00F37E;
    background: unset;
    padding: 6px 24px;
    margin-bottom: 9px;
  }

  p {
    font-family: Roboto;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 131%;
    color: #FFFFFF;
  }

  .courses {
    .content {
      position: relative;

      .shap-light {
        position: absolute;
        top: -29px;
        left: 125px;
        width: 165px;
        height: 165px;
        background: radial-gradient(38.86% 38.86% at 50% 50%, rgba(0, 227, 132, 0.5) 0%, rgba(26, 25, 29, 0) 100%);
      }

      h2 {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 144px;
        line-height: 74%;
        text-align: center;
        color: #00F37E;
      }

      .disc {
        width: 40%;
        float: right;
        text-align: left;
        position: relative;

        .shap-dot {
          position: absolute;
          width: 48px;
          height: 48px;
          left: -38px;
          top: 0;
          background: radial-gradient(25% 25% at 50% 50%, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
          transform: matrix(1, 0, 0, -1, 0, 0);
        }

        h3 {
          font-family: Roboto;
          font-style: normal;
          font-weight: bold;
          font-size: 24px;
          line-height: 100%;
          color: #FFFFFF;
        }

        hr {
          height: 4px;
          background: #FFFFFF;
          opacity: 1;
          width: 40px;
        }
      }
    }
  }
}
</style>
